<template>
  <div class="body-wrapper">
    <QuestionImage
        :attaches="questionData?.content?.attach
    ?.filter(item => item.file?.attachUrl)
    ?.map(item => ({ attachUrl: item.file.attachUrl })) || []"
    />
    <h5 class="title">
      {{ questionData?.name }}
    </h5>

    <div class="options-wrapper">

      <div
          class="option"
          v-for="option in questionData?.content?.options"
          :key="option.id"
      >
        <img src="@/assets/images/drag.svg"  height="18" />
        <span>{{option.name}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionImage from "@/components/QuestionImage.vue";

export default{
  components: {QuestionImage},
  props:{
    questionData: {
      type: Object,
      required: true
    }
  },
}
</script>

<style scoped>
.body-wrapper {
  display: flex;
  flex-direction: column;
  gap: 3px;
  width: 100%;
  padding: 10px;
}

.title {
  font-size: 18px;
  color: #040C2D;
  margin: 0;
  padding: 0;
  font-family: euclid_semi_bold, sans-serif;
}

.options-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  margin-top: 20px;
}

.option {
  width: 100%;
  background-color: #F5F5F5;
  border-radius: 8px;
  padding: 10px 10px;
  flex-shrink: 1;
  border: 2px solid transparent;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  z-index: 1;
}

.option span {
  font-size: 14px;
  color: #040C2D;
  margin: 0;
  padding: 0;
  font-family: euclid_regular, sans-serif;
}

</style>
